import ItemListView from "../../../components/ItemListView/ItemListView.vue"
import ItemView from "../../../components/ItemView/ItemView.vue"

export default [{
    "path": "/Database/ChangeRequests",
    "component": { ...ItemListView },
    "name": "Procedural Change Requests",
    "meta": {
        "app": "Database",
        "name": "Procedural Change Requests",
        "sideNav": true,
        "sideNavSection": "Quality System",
        "appSwitcher": false,
        "icon": "database",
        "tableSettings": "ChangeRequests",
        "dataPath": "Database/ChangeRequests",
        "selectionRoute": "Database/ChangeRequests/{ID}",
        lock(user) {
            return [user?.Security?.General?.UserAdmin !== true, "Cannot view this area"]
        },
        "menuActions": []
    }
}, {
    "path": "/Database/ChangeRequests/:id",
    "component": ItemView,
    "name": "Procedural Change Request",
    "meta": {
        "app": "Database",
        "name": "Procedural Change Request",
        "dataPath": "Database/ChangeRequests",
        "dataPathOverride": "Database/ChangeRequests/:id",
        "selectionRoute": "Database/ChangeRequests/{ID}",
        "storeData": ["Database/MFARQuestions"],
        title(item) {
            return `Procedural Change Request: ${item.Name}`;
        },
        "attachedItems": {

        },
        "dataFields": [{
            "label": "Work Instruction",
            "key": "WorkInstruction",
            "link": "Database/WorkInstructions/:WorkInstructionID"
        }, {
            "label": "Handbook",
            "key": "Handbook",
            "link": "Database/Handbooks/:HandbookID"
        }, {
            "label": "Date Created",
            "key": "Date",
            "type": "date"
        }, {
            "label": "Status",
            "key": "Status"
        }, {
            "label": "Change Request",
            "key": "Note",
            "grow": true,
            "class": "col-span-3"
        }],
        "menuActions": []
    }
}];
